export class  CourseCatalogueSearch{
    eQMSScopes?:string[];
    owners?:string[];
    qualifiedTrainers?:string[];
    status?:string[];
    format?:string[];
    searchText?: string
}
